export enum EMedicamentType {
  Medicine = 'Thuốc',
  Musculoskeletal = 'Cơ xương khớp',
  Allergy = 'Dị ứng',
  ReduceFeverAndPain = 'Hạ sốt, giảm đau',
  Respiratory = 'Hô hấp',
  Antibiotic = 'Kháng sinh',
  AntiInflammatory = 'Kháng viêm',
  Endocrine = 'Nội tiết',
  Psychoactive = 'Thần kinh',
  Urinary = 'Tiết niệu',
  HepatobiliaryDigestive = 'Tiêu hoá gan mật',
  Cardiovascular = 'Tim mạch',
  EyeDrops = 'Nhỏ mắt',
  FunctionalFoodVitamin = 'Vitamin TPCN'
}
